import React, { useContext } from 'react';
import { gql, useQuery } from '@apollo/client';
import ProductPageContext from '../../contexts/ProductPageContext';
import OutfitCarousel from './OutfitCarousel/OutfitCarousel';
import OutfitCard from './OutfitCard/OutfitCard';
import OutfitCardSkeleton from './OutfitCard/OutfitCardSkeleton';

const getOutfitsQuery = gql`
  query GetOutfits($kicId: String!) {
    outfits(kicId: $kicId) {
      kicId
      collectionId
      productId
      name
      imageUrl
      prices {
        list {
          originalPrice
          discountPrice
          description
        }
      }
    }
  }
`;

export default function OutfittingWidget() {
  const ProductPageState = useContext(ProductPageContext);
  const { hasOutfittingPdpEnabled } = ProductPageState?.collectionData || {};
  const { kicId, hasProductSets } = ProductPageState?.collectionData?.activeProduct || {};
  const shouldRequestOutfits = hasOutfittingPdpEnabled && hasProductSets;
  const { data, loading, error } = useQuery(getOutfitsQuery, {
    variables: { kicId },
    skip: !shouldRequestOutfits || !kicId,
  });

  if (!shouldRequestOutfits || error) {
    return null;
  }

  const outfits = data?.outfits;

  if (!loading && (!outfits || outfits.length === 0)) {
    return null;
  }

  // Compute slides based on loading state and data
  const slides = loading ? (
    Array.from({ length: 3 }, (_, index) => (
      <OutfitCardSkeleton key={`skeleton-${index}`} />
    ))
  ) : (
    outfits.map((outfit) => (
      <OutfitCard
        key={outfit.map((product) => product.kicId).join('-')}
        products={outfit}
      />
    ))
  );

  return (
    <OutfitCarousel>
      {slides}
    </OutfitCarousel>
  );
}
